// extracted by mini-css-extract-plugin
export default {"wrapper":"simonMain_wrapper__KqBs5","buttons":"simonMain_buttons__peLB6","btnActive":"simonMain_btnActive__5Bnlg"};